import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg, formatRupiah } from "@/lib/api";

export const VoidDialog = ({ tx, onClose, onDone }) => {
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => setReason(""), [tx?.id]);

  const submit = async () => {
    if (reason.trim().length < 3) return toast.error("Alasan minimal 3 karakter");
    setSaving(true);
    try {
      await api.post(`/transactions/${tx.id}/void`, { reason: reason.trim() });
      toast.success(`Transaksi ${tx.invoice_no} dibatalkan, stok dikembalikan`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={!!tx} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" aria-describedby={undefined} data-testid="void-dialog">
        <DialogTitle className="font-display">Batalkan Transaksi</DialogTitle>
        {tx && (
          <div className="rounded-xl bg-red-50 p-4 text-sm text-red-800">
            <p className="font-mono font-semibold">{tx.invoice_no} &middot; {formatRupiah(tx.total)}</p>
            <p className="mt-1">Stok semua barang akan dikembalikan. Transaksi tidak dihitung lagi di laporan dan pindah ke tab "Dibatalkan".</p>
          </div>
        )}
        <div className="space-y-1.5">
          <Label htmlFor="void-reason">Alasan pembatalan</Label>
          <Textarea id="void-reason" rows={3} maxLength={200} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="mis. salah input barang / pembeli batal" data-testid="void-reason-input" />
        </div>
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1" onClick={onClose} data-testid="void-cancel-button">Kembali</Button>
          <Button disabled={saving} onClick={submit} className="flex-1 bg-red-600 hover:bg-red-700" data-testid="void-confirm-button">
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Batalkan Transaksi
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
